<template>
  <div>
    <panel-header>
      <back-link slot="arrow">
        <panel-header-back-arrow />
      </back-link>
      <span slot="text">Гороскоп</span>
    </panel-header>
    <div class="row">
      <div class="col">
        <p class="default-text">Выберите знак зодиака, чтобы узнать гороскоп на сегодня.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-4" v-for="sign in hs.getSigns()" :key="sign">
        <div class="sign" @click="showHoroscopeSign(sign)">
          <div class="sign-icon">
            <component v-bind:is="capitalizeSign(sign)"></component>
          </div>
          {{ hs.getSignName(sign) }}
        </div>
      </div>
      <div class="col-12 text-center mt-3" v-if="! isMobile">
        <back-link />
      </div>
    </div>
  </div>
</template>

<script>
import { isIPhone, today} from "@/lib/utils";
import {store} from "@/store";
import horoscopeService from "@/services/horoscope";

import PanelHeader from "@/components/PanelHeader/PanelHeader";
import BackLink from "@/components/_Utlis/BackLink";
import PanelHeaderBackArrow from "../../components/PanelHeader/PanelHeaderBackArrow";
import client from "@/services/client";
import Aquarius from "@/components/Icons/Zodiacs/Aquarius";
import Aries from "@/components/Icons/Zodiacs/Aries";
import Cancer from "@/components/Icons/Zodiacs/Cancer";
import Capricorn from "@/components/Icons/Zodiacs/Capricorn";
import Gemini from "@/components/Icons/Zodiacs/Gemini";
import Leo from "@/components/Icons/Zodiacs/Leo";
import Pisces from "@/components/Icons/Zodiacs/Pisces";
import Sagittarius from "@/components/Icons/Zodiacs/Sagittarius";
import Scorpio from "@/components/Icons/Zodiacs/Scorpio";
import Taurus from "@/components/Icons/Zodiacs/Taurus";
import Virgo from "@/components/Icons/Zodiacs/Virgo";
import Libra from "@/components/Icons/Zodiacs/Libra";
import bridge from "@vkontakte/vk-bridge";
import Spinner from "../../components/_Utlis/Spinner";

export default {
  name: "Horoscope",
  components: {
    Spinner,
    Libra,
    Virgo,
    Taurus,
    Scorpio,
    Sagittarius,
    Pisces,
    Leo,
    Gemini,
    Capricorn,
    Cancer,
    Aries,
    Aquarius,
    PanelHeaderBackArrow,
    BackLink,
    PanelHeader,
  },
  data(){
    return {
      hs: horoscopeService,
    }
  },
  mounted() {
    bridge.send("VKWebAppScroll", {"top": 0, "speed": 0});
  },
  methods: {
    showHoroscopeSign(sign) {
      this.$root.$emit('showHoroscopeSign', sign);
    },
    capitalizeSign(sign) {
      return sign.charAt(0).toUpperCase() + sign.slice(1);
    },
    isIPhone() {
      return isIPhone(store);
    },
    today() {
      return today();
    }
  },
  computed: {
    isMobile() {
      return client.isMobile();
    },
  }
}
</script>

<style lang="scss" scoped>
  @import "../../scss/partials/containers";

  .title {
    text-align: center;
    font-weight: bold;
    margin-bottom: 32px;
    font-size: 36px;
    line-height: 1;
  }

  .sub-title {
    font-size: 24px;
  }

  .sign {
    @extend .white-wrapper;
    text-align: center;
    cursor: pointer;
    font-weight: 500;
    font-size: 12px;
    margin-bottom: 14px;
  }

  .sign-icon {
    height: 24px;
    width: auto;
    display: block;
    margin: 0 auto 7px;
    fill: var(--zodiac-svg-fill);
  }

  .default-text {
    color: var(--default-text-color);
  }

  @media (max-width: 600px) {
    .sign {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-items: center;
      justify-content: center;
    }

    .sign-icon {
      height: 24px;
      width: auto;
      margin: 0 auto 3px;
    }
  }
</style>